import {
    List, Space, Tag, Typography,
} from 'antd';
import { InspectorEvent } from '../../interfaces/inspector.interface';
import { UNFULFILLMENT_EVENTS } from '../../const/events';

const { Text } = Typography;

const statusColor: any = {
    guest: 'cyan',
    business: 'gold',
};

const InspectorEventCard = ({ eventData }: { eventData: InspectorEvent }) => {
    const event = new InspectorEvent(eventData);
    const { registeredBy, description } = event;

    const getAdditionalInfo = (event: InspectorEvent) => {
        switch (event.type) {
        case UNFULFILLMENT_EVENTS.NO_BIG_COURIERS: {
            console.log(event);
            if (event?.metadata?.orderErrors?.length > 0) {
                return (
                    <List
                        dataSource={event?.metadata?.orderErrors}
                        itemLayout="horizontal"
                        renderItem={(item: any) => (
                            <List.Item key={item._id}>
                                <List.Item.Meta
                                    style={{ alignItems: 'start', margin: '10px 0' }}
                                    avatar={null}
                                    title={item?.providerName}
                                    description={item?.error}
                                />
                            </List.Item>
                        )}
                    />
                );
            }
            return null;
        }

        default:
            return null;
        }
    };

    return (
        <Space direction="vertical">
            {
                event.tag && (
                    <Tag color={event.tag.color} style={{ fontSize: '10px' }}>
                        {event.tag.key}
                    </Tag>
                )
            }
            <Text>
                {description}
            </Text>
            {
                registeredBy && (
                    <Tag color={statusColor[registeredBy.role]}>
                        {registeredBy.role.toUpperCase()}
                    </Tag>
                )
            }
            {getAdditionalInfo(event)}
        </Space>
    );
};

export default InspectorEventCard;
